import { assign } from "../../helper.js";
import { isString } from "es-toolkit";
//#region ../erd-editor-schema/dist/v3/parser/domain.entity.js
var createDomain = () => ({
	id: "",
	name: "",
	category: "",
	dataType: "",
	description: "",
	order: ""
});
function createAndMergeDomainEntities(values) {
	const entities = {};
	for (const value of values) {
		const target = createDomain();
		const assignString = assign(isString, target, value);
		assignString("id");
		assignString("name");
		assignString("category");
		assignString("dataType");
		assignString("description");
		assignString("order");
		if (target.id) entities[target.id] = target;
	}
	return entities;
}
//#endregion
export { createAndMergeDomainEntities, createDomain };
